import { BASE_URL_PROD } from '../../../components/config/keys';
import React,{ useState,useEffect } from "react";
import { useTranslation } from 'react-i18next';
import getTranslation from '../../../utils/getTranslation';
import './styles.scss';
import { Container, Row, Col, Form, Button,Nav,ListGroup,ListGroupItem,Card,Table,Modal,CloseButton} from "react-bootstrap";

import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { SET_CURRENT_COMMANDE} from "../../../constants/actions";
import "react-datepicker/dist/react-datepicker.css";
import { Menu } from "../../../components";
import moment from 'moment'
import { apiClient } from "../../../actions/api"

import 'moment/locale/fr';
import FullCalendar from '@fullcalendar/react' // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';

import { getPatientLocalReservations, getNextConsultation } from "../../../actions/api_interface"
import ShowTimezone from '../../../components/show_timezone/'
import NextConsultation from '../../../components/next_consultation'



const Page = () => {
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const { user } = useSelector(state => state.user)
    const [datedif, setDatedif] = useState('')
    const [idreservation, setIdReservation] = useState(1)
    const [is24, setIs24] = useState(false)

    const [eventconsulation, setEventconsulation] = useState('')
    const [consulations, setConsulations] = useState('')
    const [rendezvous, setrendezvous] = useState('')


    const history = useHistory();

    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const handleCloseAlert = () => setShowAlert(false);


    const [checkconsultation, setCheckconsultation] = useState({})




 useEffect(() => {


    getAllReservation()
    checkifconsultation()


  let eleme1=document.querySelector(".fc-dayGridMonth-button");
       let eleme2=document.querySelector(".fc-timeGridWeek-button");
       eleme1.innerText='Mois'
       eleme2.innerText='Semaine'

}, []);



  function getAllReservation () {
    getPatientLocalReservations(user, setConsulations)
  }




  const toggle = ({ event, el }) => {
     setEventconsulation('')

     setIdReservation(event._def.publicId)
     setrendezvous(event._def.extendedProps)

     let daterdv=event._def.extendedProps?.date_rdv+'T'+event._def.extendedProps?.heure_rdv

     let mmdate=moment().diff(daterdv, 'hours');

     if(parseInt(Math.abs(mmdate)) < 24){

      setIs24(true)
     }

     setDatedif(moment().diff(daterdv, 'hours'))

     setShowAlert(true)
  };


  const handleConfirm = (id) => {

      if(eventconsulation==1){

             setEventconsulation(3)



      }
      else{

             anullerdv(id)

      }
  };
const anullerdv = (id) => {

          let params={
              token:user.api_token,
              api_token:user.api_token,
              id:idreservation,
              action:'anuller'
          }


          apiClient().post(`/set/reservation`,params )
           .then((res) => {

              if(res.data.success=='ok'){
                       getAllReservation()
                       setAlertMessage(t('appointment.cancelled'))
                       handleCloseAlert();
                       setTimeout(function(){ setAlertMessage('')}, 5000);
                       checkifconsultation()

              }


           })



}
const deplacerdv = async (e) => {



        e.preventDefault();
        const formData = new FormData(e.target)
        const formDataObj = Object.fromEntries(formData.entries())


      let daterdv=formDataObj.date+'T'+formDataObj.heure
      let datediff=moment().diff(daterdv, 'hours')
      if(datediff>=0){

          alert(t('common.date_expired'))
          return false;

      }





          let params={

              token:user.api_token,
              api_token:user.api_token,
              id:idreservation,
              action:'deplacer',
              date:formDataObj.date,
              heure:formDataObj.heure
          }




          apiClient().post(`/set/reservation`,params )
           .then((res) => {

              if(res.data.success=='ok'){

                    getAllReservation()
                    setAlertMessage(t('appointment.modification_pending'))
                    handleCloseAlert();
                    setTimeout(function(){ setAlertMessage('')}, 7000);
                    checkifconsultation()

              }


           })



}





    function checkifconsultation() {
        let params={

              token:user.api_token,
              api_token:user.api_token,
          }


          apiClient().post(`/check/consultation/therapeut`,params )
           .then((res) => {
              if(res.data.success=='ok'){
                if(res.data.reservation?.heure_rdv){
                  setCheckconsultation(res.data.reservation)

                }

              }


           })
    }


  const nextConsultation = getNextConsultation(consulations)

    return (
        <div className="mescommandes register vosventes bg778635 " >
            <Container>
                <Row>
              <Col  className="text-center mx-auto my-5"  lg="3">

                  <Menu slug='mesrendezvous' />

                </Col>

                    <Col  className="text-center mx-auto my-5 menudashright"  >
                            <h3 className="mb-4">{t('appointment.my_appointments')}</h3>
                            {
                              alertMessage &&

                              <div className='alert alert-success'>
                                {alertMessage}
                              </div>
                            }
                            <NextConsultation consultation={nextConsultation} target={"/conference/call/" + nextConsultation?.therapeute?.user_id} />




                  <div className='agenda'>


      <ShowTimezone />
      <FullCalendar

        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        weekends={true}
        initialView="dayGridMonth"
        headerToolbar={{
        start: 'title,prev,next',
        center: 'customButtons',
        end: 'dayGridMonth,timeGridWeek'
        }}
        locale={'fr'}
        timeZone= {'local'}
        events={consulations}
        eventClick={toggle}



      />



                             </div>





                    </Col>
                </Row>

<Modal show={showAlert} onHide={handleCloseAlert} size="lg"  centered>
        <Modal.Header closeButton>

        </Modal.Header>
        <Modal.Body>



        <Row className="mb-3 abonnement text-center "  >



          <div className='itemimg col-md-3' style={{backgroundImage:rendezvous?.therapeute?.picture ? `url(${BASE_URL_PROD + "gestion/public/uploads/"+rendezvous?.therapeute?.picture})` : "url('/images/default-profile.png')"}}></div>
          <h3 style={{marginBottom: '3px',marginTop: '18px'}}>{rendezvous?.therapeute?.name}</h3>
          <div style={{marginBottom: '30px'}}>
            <a href='javascript:void(0)' onClick={()=>history.push('/messages?p='+rendezvous?.therapeute?.user_id)} style={{textDecoration: 'underline' ,color: '#17a2b8'}}>{t('appointment.contact_therapist')}</a>
          </div>


                   <div className='row'>


                                         <div className='item col-md-3' style={{paddingBottom:'10px'}}>{t('appointment.your_need_label')} <br/><strong>{getTranslation(rendezvous?.tarif?.titre, i18n.language)}</strong></div>
                                         <div className='item col-md-3' style={{paddingBottom:'10px'}}>{t('appointment.your_formula_label')}<br/> <strong>{getTranslation(rendezvous?.formule?.titre, i18n.language)}</strong></div>
                                         <div className='item col-md-3' style={{paddingBottom:'10px'}}>{t('common.col_date')}:<br/> <strong>{moment.utc(rendezvous?.time).local().format("DD/MM/YYYY")}</strong></div>
                                         <div className='item col-md-3' style={{paddingBottom:'10px'}}>{t('common.col_time')}:<br/> <strong>{moment.utc(rendezvous?.time).local().format("HH:mm")}</strong></div>

                  </div>




          <div>


           {
            (rendezvous?.status==1 && datedif <=0) ?

                is24 === true ?
                  <div class="flexitems"><a style={{    opacity: '0.4'}} class="btnlink marauto">{t('appointment.move_consultation')}  </a><a style={{opacity: '0.4'}} class="btnlink marauto btnlinkjaun">{t('appointment.cancel_consultation')}   </a></div>
                :
                 <div class="flexitems"><a href="javascript:void(0)" onClick={()=>setEventconsulation(1)} class="btnlink marauto">{t('appointment.move_consultation')}  </a><a href="javascript:void(0)" onClick={()=>setEventconsulation(2)} class="btnlink marauto btnlinkjaun">{t('appointment.cancel_consultation')}   </a></div>

             :
             (rendezvous?.status==1 && datedif > 0) ?
             <div class="flexitems"><div className='alert alert-danger' style={{    width: '100%'}}>{t('appointment.date_passed')}</div></div>
             :
             (rendezvous?.status==3) ?
             <div class="flexitems"><div className='alert alert-danger' style={{    width: '100%'}}>{t('appointment.cancelled')}</div></div>
             :
             (rendezvous?.status==4) ?
             <div class="flexitems"><div className='alert alert-warning' style={{    width: '100%'}}>{t('appointment.moved_pending')}</div></div>
             :
             (rendezvous?.status==5) ?
             <div class="flexitems"><div className='alert alert-danger' style={{    width: '100%'}}>{t('appointment.not_honored')}</div></div>
             :
             <div class="flexitems"><div className='alert alert-success' style={{    width: '100%'}}>{t('appointment.session_completed')}</div></div>

           }


          </div>


          </Row>








        </Modal.Body>
        <Modal.Footer>
        {
          (eventconsulation ==1 || eventconsulation==2) &&

          <div className='alert alert-warning footermodflex'>{t('appointment.cancellation_policy')}  <Button variant="secondary" onClick={()=>handleConfirm(rendezvous?.publicId)} style={{background: '#000'}}>
            {t('common.confirm')}
          </Button></div>


        }
          {
          (eventconsulation ==3) &&

          <div className='alert alert-warning' style={{display:'block',width: '100%'}}>

          <Form onSubmit={deplacerdv} className="forMMp" style={{justifyContent: 'center'}}>

          {
            /*
                <input type="date" name='date' className='form-control' style={{marginRight:'10px'}}  required/>
                <input type="time" name='heure' className='form-control' style={{marginRight:'10px'}} required/>

                <Button variant="secondary" type="submit" style={{background: '#000'}}>
                  Déplacer
                </Button>
            */
          }

            <a className='btnlink' onClick={()=>history.push('/agenda-psychologue/'+idreservation+'/'+rendezvous?.therapeute?.user_id)} style={{background: '#000',    float: 'right',
    color: '#FFF',
    cursor: 'pointer'}}>
                  {t('appointment.choose_new_date')}
            </a>









          </Form>
             </div>






        }


        </Modal.Footer>
</Modal>

            </Container>
        </div>
    );
}

export default Page;